import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 text-sm border-t border-gray-800 py-4 px-6 flex justify-between items-center">
      <p>© {new Date().getFullYear()} Kwame O. Sarfo. All Rights Reserved.</p>
      <a
        href="https://wa.me/233504808819" 
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-300 hover:text-[#d4af37] transition"
      >
        Developed by Wills
      </a>
    </footer>
  );
};

export default Footer;
